<template>
    <div v-if="props.type === 'initials' || props.type === 'icon'">
        <component
            :is="props.icon"
            v-if="props.type !== 'initials'"
            class="ring-inset ring-1 ring-gray-950/20 flex justify-center items-center bg-gray-100 text-gray-600"
            :class="setClassAvatar"
        ></component>
        <div v-else class="ring-inset font-medium ring-1 ring-gray-950/20 flex justify-center items-center bg-gray-100 text-gray-600" :class="setClassAvatar">{{ initials }}</div>
    </div>
    <figure v-else :class="setClassAvatar">
        <div class="absolute ring-inset ring-1 ring-gray-950/20 z-50" :class="setClassAvatar"></div>
        <img class="absolute" :class="setClassAvatar" :src="face" alt="Profile image" />
    </figure>
</template>

<script setup>
import { computed } from 'vue';
import { UserIcon } from '@heroicons/vue/24/solid';
import face from '@/assets/images/face.png';

const props = defineProps({
    type: {
        type: String,
        default: 'initials'
    },
    isCircle: {
        type: Boolean,
        default: false
    },
    size: {
        type: String,
        default: 'md'
    },
    avatarName: {
        type: String,
        default: ''
    },
    icon: {
        type: Function,
        default: UserIcon
    }
});

const initials = computed(() => props.avatarName.slice(0, 1).toUpperCase());

const setClassAvatar = computed(() => {
    let style = '';
    let size = '';
    if (props.size === 'xs') size = 'h-5 min-w-5';
    else if (props.size === 'sm') size = 'h-6 min-w-6';
    else if (props.size === 'lg') size = 'h-10 w-10';
    else size = 'h-8 w-8';
    if (props.isCircle) style = 'rounded-full';
    else {
        if (style === 'sm') style = 'rounded-sm';
        else if (style === 'lg') style = 'rounded-lg';
        else style = 'rounded-md';
    }
    if (props.type === 'icon') {
        if (props.size === 'xs') size = size + ' p-1';
        else if (props.size === 'sm') size = size + ' p-1';
        else if (props.size === 'lg') size = size + ' p-2';
        else size = size + ' p-[6px]';
    } else if (props.type === 'initials') {
        if (props.size === 'xs') size = size + ' text-xs py-1 leading-4';
        else if (props.size === 'sm') size = size + ' text-xs py-1 leading-4';
        else if (props.size === 'lg') size = size + ' text-lg py-2 leading-6';
        else size = size + ' text-sm py-[6px] leading-5';
    }
    return `${style} ${size}`;
});
</script>
